import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
function ProtectedRoute(_a) {
    var children = _a.children;
    var _b = useAuth0(), isLoading = _b.isLoading, isAuthenticated = _b.isAuthenticated;
    return (_jsx(_Fragment, { children: (isLoading || isAuthenticated) ? children : _jsx(Navigate, { to: "/signin" }) }));
}
export default ProtectedRoute;
